export default __webpack_public_path__ + "static/luit-9c7c79ae51251f09a11b67f3f9abb9c7.jpg";